import PropTypes from "prop-types";
import {FormattedMessage} from "react-intl";
import messages from "./messages";
import {Close} from "@material-ui/icons";
import {Dialog, DialogActions, DialogContent, DialogTitle, IconButton,} from "@material-ui/core";
import {makeStyles} from "@material-ui/core/styles";
import RefrezhButton from "components/RefrezhButton";

const useStyles = makeStyles(theme => ({
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
}));

function DocumentOrderModal({
  isOpen = false,
  onClose,
  onCancel,
  onConfirm,
  dataCy,
  content,
  title,
  cancelText = <FormattedMessage {...messages.cancel} />,
  confirmText = <FormattedMessage {...messages.ok} />,
}) {
  const classes = useStyles();

  return (
    <Dialog open={isOpen} onClose={onClose} data-cy={dataCy}>
      <DialogTitle>
        <div className={classes.header}>
          <div>{title}</div>
          <IconButton onClick={onClose}>
            <Close />
          </IconButton>
        </div>
      </DialogTitle>
      <DialogContent>
        <p>{content}</p>
      </DialogContent>
      <DialogActions>
        <div data-cy="cancelButton">
          <RefrezhButton onClick={()=>{
            onClose();
            if(onCancel) {
              onCancel();
            }
          }}>{cancelText}</RefrezhButton>
        </div>
        <div data-cy="confirmButton">
          <RefrezhButton onClick={onConfirm}>{confirmText}</RefrezhButton>
        </div>
      </DialogActions>
    </Dialog>
  );
}

DocumentOrderModal.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  onCancel: PropTypes.func,
  onConfirm: PropTypes.func.isRequired,
  deleteMessage: PropTypes.any,
  content: PropTypes.object,
  title: PropTypes.object,
};

export default DocumentOrderModal;
